import { TransitOperation } from '../models/types'
import { TransitOperationSave } from '../models/request'
import { updateTransitOperation } from './updateTransitOperation'
import { createTransitOperation } from './createTransitOperation'

// eslint-disable-next-line import/prefer-default-export
export async function createOrUpdateTransitOperation(
  id: number | null,
  transitOperation: TransitOperationSave,
): Promise<TransitOperation> {
  if (id != null) {
    return await updateTransitOperation(id, transitOperation)
  }

  return createTransitOperation(transitOperation)
}
